import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";

const events = [
  { "title": "First Met", "year": "2018" },
  { "title": "First Spoke", "year": "2018" },
  { "title": "First Messaged", "year": "2018" },
  { "title": "First Date", "year": "2018" },
  { "title": "First Kiss", "year": "2018" },
  { "title": "First \"I love you\"", "year": "2018" },
  { "title": "First Party Together", "year": "2018" },
  { "title": "First time introducing you as \"my girlfriend\"", "year": "2018" },
  { "title": "First photo together", "year": "2018" },
  { "title": "First kiss", "year": "2018" },
  { "title": "First time holding hands", "year": "2018" },
  { "title": "First awkward silence", "year": "2018" },
  { "title": "First Dullies Weekend", "year": "2019" },
  { "title": "First Holiday", "year": "2019" },
  { "title": "First Anniversary", "year": "2019" },
  { "title": "First Birthdays Together", "year": "2019" },
  { "title": "First Valentine's Day", "year": "2019" },
  { "title": "First Fight", "year": "2019" },
  { "title": "First Time meeting parents", "year": "2019" },
  { "title": "First time brushing teeth together", "year": "2019" },
  { "title": "First lazy morning in bed", "year": "2020" },
  { "title": "First family gathering together", "year": "2020" },
  { "title": "First compromise", "year": "2021" },
  { "title": "First time running errands together", "year": "2021" },
  { "title": "First long-distance strech", "year": "2022" },
  { "title": "First time breaking up lol", "year": "2022" },
  { "title": "First time getting back together", "year": "2023" },
  { "title": "First Road trip", "year": "2024" },
  { "title": "First serious future conversation", "year": "2024" },
  { "title": "First Grocery Shop Together", "year": "2025" },
  { "title": "First night living together", "year": "2025" }
];

const MotionBox = motion(Box);

const fadeUp = {
  hidden: { opacity: 0, y: 80 },
  visible: { opacity: 1, y: 0 },
};

export default function App() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top, #ffd6e8 0%, #fbc2eb 30%, #a6c1ee 100%)",
        overflow: "hidden",
        py: 10,
      }}
    >
      {/* Floating Hearts */}
      {[...Array(12)].map((_, i) => (
        <MotionBox
          key={i}
          sx={{
            position: "absolute",
            left: `${Math.random() * 100}%`,
            bottom: -50,
            fontSize: `${Math.random() * 24 + 18}px`,
            opacity: 0.5,
            color: "#ff4d6d",
          }}
          animate={{ y: [-50, -1200], opacity: [0, 0.6, 0] }}
          transition={{
            duration: Math.random() * 12 + 10,
            repeat: Infinity,
            delay: Math.random() * 5,
          }}
        >
          ❤️
        </MotionBox>
      ))}

      <Container maxWidth="sm">
        {/* Title */}
        <MotionBox
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2 }}
          textAlign="center"
          mb={10}
        >
          <Typography
            sx={{
              fontSize: "2.6rem",
              fontFamily: "'Playfair Display', serif",
              color: "#6a1b4d",
              textShadow: "0 10px 30px rgba(255,77,109,0.4)",
            }}
          >
            Our Story
          </Typography>
          <Typography sx={{ opacity: 0.75 }}>
            A timeline of us 💕
          </Typography>
        </MotionBox>

        {/* Timeline */}
        <Box position="relative" pl={3}>
          {/* Vertical Glow Line */}
          <Box
            sx={{
              position: "absolute",
              left: 10,
              top: 0,
              bottom: 0,
              width: 4,
              background:
                "linear-gradient(to bottom, rgba(255,77,109,0.5), rgba(255,77,109,0.1))",
              borderRadius: 4,
              boxShadow: "0 0 20px rgba(255,77,109,0.5)",
            }}
          />

          {events.map((event, i) => (
            <MotionBox
              key={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: i * 0.15 }}
              display="flex"
              mb={8}
            >
              {/* Pulse Dot */}
              <MotionBox
                animate={{ scale: [1, 1.4, 1] }}
                transition={{ repeat: Infinity, duration: 2 }}
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  background:
                    "radial-gradient(circle, #ff4d6d, #ff758f)",
                  boxShadow: "0 0 15px rgba(255,77,109,0.9)",
                  mt: 1,
                  mr: 3,
                  flexShrink: 0,
                }}
              />

              {/* Card */}
              <Box
                sx={{
                  background: "rgba(255,255,255,0.6)",
                  backdropFilter: "blur(14px)",
                  borderRadius: 5,
                  p: 3,
                  boxShadow: "0 30px 60px rgba(0,0,0,0.15)",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    color: "#6a1b4d",
                  }}
                >
                  {event.title}
                </Typography>
                <Typography sx={{ opacity: 0.7 }}>
                  {event.year}
                </Typography>
              </Box>
            </MotionBox>
          ))}

          {/* FINAL GRAND MOMENT */}
          <MotionBox
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4 }}
            mt={14}
            textAlign="center"
          >
            <MotionBox
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ repeat: Infinity, duration: 3 }}
              sx={{
                mx: "auto",
                width: 28,
                height: 28,
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, #fff, #ff9a9e)",
                boxShadow: "0 0 30px rgba(255,154,158,1)",
                mb: 4,
              }}
            />

            <Box
              sx={{
                background:
                  "linear-gradient(135deg, #ff9a9e, #fad0c4)",
                borderRadius: 6,
                p: 4,
                color: "white",
                boxShadow: "0 40px 80px rgba(0,0,0,0.3)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1.8rem",
                  fontFamily: "'Playfair Display', serif",
                  mb: 1,
                }}
              >
                First Christmas Together
              </Typography>

              <Typography sx={{ opacity: 0.9, mb: 3 }}>
                2025 🎄
              </Typography>

              <Typography sx={{ lineHeight: 1.8 }}>
                Every year we’ve shared has given us new firsts, memories that didn’t exist until we made them together.
And even after so many firsts, I know this will never be the last.
There will always be another year, another moment, another first waiting for us.
I can’t wait to live them all with you ❤️
              </Typography>
            </Box>
          </MotionBox>
        </Box>
      </Container>
    </Box>
  );
}
